export default __webpack_public_path__ + "static/media/maternidad3_g.ff2a4a9f.jpg";